import { render, staticRenderFns } from "./card-button.vue?vue&type=template&id=faf9635a&"
import script from "./card-button.vue?vue&type=script&lang=js&"
export * from "./card-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faf9635a')) {
      api.createRecord('faf9635a', component.options)
    } else {
      api.reload('faf9635a', component.options)
    }
    module.hot.accept("./card-button.vue?vue&type=template&id=faf9635a&", function () {
      api.rerender('faf9635a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/component/card-button.vue"
export default component.exports